import React from 'react';
import { Typography, Box } from '@mui/material';

function Guards() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Guards Management
      </Typography>
      <Typography variant="body1">
        Guard management functionality coming soon...
      </Typography>
    </Box>
  );
}

export default Guards; 